import React, { useEffect, useState } from 'react';
import './edit-profile.sass';
import * as Yup from 'yup';
import { Input } from '../../../../../components/interface/input/input';
import { Dropdown } from '../../../../../components/interface/input/dropdown/dropdown';
import { TextArea } from '../../../../../components/interface/input/textarea/textarea';
import { useFormik } from 'formik';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories, patchVendor } from '../../dashboard-profile.slice';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { getSession } from '../../../../login/session.slice';
import { DropdownTown } from '../../../../../components/interface/input/dropdown/town/dropdown-town';

const FormSchema = Yup.object().shape({
    name: Yup.string().min(3, 'Za mało!').max(25).required('Pole wymagane!'),
    category: Yup.string(),
    url: Yup.string().url('Podaj poprawny url!').required('Podaj poprawny url!'),
    address: Yup.string().required('Pole wymagane!'),
    description: Yup.string().max(200, 'Za dużo!').required('Pole wymagane!'),
});

export const EditProfile = ({isOpen = true, setIsVisible, vendor}) => {

    const dispatch = useDispatch();
    const categories = useSelector(state => state.dashboardProfile.categories);

    useEffect(() => {
        dispatch(getCategories({}));
    }, []);

    const formik = useFormik({
        initialValues: {
            name: vendor.name,
            category: '',
            url: vendor.url,
            city: vendor.city,
            address: vendor.address,
            description: vendor.description,
        },
        validationSchema: FormSchema,
        onSubmit: (values) => {
            dispatch(patchVendor({vendorId: vendor.id, payload: values}))
                .then(unwrapResult)
                .then(() => {
                    toast.success('formularz wysłany');
                    dispatch(getSession({}));
                    setIsVisible(false);
                }, () => {
                    toast.error('coś poszło nie tak');
                })
                .catch(e => {
                    toast.error(e.message);
                });
        }
    });

    useEffect(() => {
        return () => {
            formik.resetForm();
        };
    }, [isOpen]);

    return (
        <div className='vv-vendor-dashboard-profile-edit-container'>
            <h2>Edytuj profil usługi</h2>
            <form onSubmit={formik.handleSubmit}>
                <div className='vv-vendor-dashboard-profile-edit'>
                    <div className='vv-vendor-dashboard-profile-edit__input-container'>
                        <div className='vv-vendor-dashboard-profile-edit__input-margin'>
                            <Input label='Nazwa' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='name' id='name'
                                   value={formik.values.name}
                                   textError={formik.touched.name && formik.errors.name}/>
                        </div>
                        <div className='vv-vendor-dashboard-profile-edit__input-margin'>
                            <Dropdown name='category' id='category' label='Branża'
                                      value={formik.values.category}
                                      onBlur={formik.handleBlur} onChange={(option) => formik.setFieldValue('category', option.value)}
                                      options={categories.map((category) => ({value: category.id, label: category.label}))}/>
                        </div>
                        <div className='vv-vendor-dashboard-profile-edit__input-margin'>
                            <Input label='Link do strony' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='url' id='url'
                                   value={formik.values.url}
                                   textError={formik.touched.url && formik.errors.url}/>
                        </div>
                        <div className='vv-vendor-dashboard-profile-edit__input-margin'>
                          <DropdownTown name='city' id='city' value={formik.values.city}
                                        onChange={(option) => formik.setFieldValue('city', option)}/>
                        </div>
                        <Input label='Lokalizacja' onBlur={formik.handleBlur} onChange={formik.handleChange}
                               name='address' id='address'
                               value={formik.values.address}
                               textError={formik.touched.address && formik.errors.address}/>
                    </div>
                    <div className='vv-vendor-dashboard-profile-edit__text-area-container'>
                        <div className='vv-vendor-dashboard-profile-edit__text-area-margin'>
                            <TextArea label='Opis twojej działalności'
                                      name='description' id='description'
                                      value={formik.values.description}
                                      onBlur={formik.handleBlur} onChange={formik.handleChange}
                                      textError={formik.touched.description && formik.errors.description}/>
                        </div>
                    </div>
                </div>
            </form>
            <div className='vv-vendor-dashboard-profile-edit__button-container'>
                <div className='margin-right'>
                    <Button text='ZAPISZ' type='submit' size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} onClick={formik.submitForm}/>
                </div>
                <Button text='ANULUJ' size={ButtonSize.VENDOR} buttonType={ButtonType.TRANSPARENT_BORDER} onClick={() => setIsVisible(false)}/>
            </div>
        </div>
    );
};
